<template>
  <div>
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div v-if="redeBloqueada" class="notification is-primary">
            Não foi possível acessar alguns recursos de rede necessários para o funcionamento da plataforma. Verifique com o departamento de tecnologia da informação da sua empresa se o acesso a porta "15984" é liberado. Opcionalmente, acesse a plataforma utilizando uma rede móvel.
          </div>


          <div class="column is-4 is-offset-4">
            <img src="../assets/img/200_118_versaopositiva.png" border="0" width="200.8" height="118.2"/>
            <div class="box">
              <!-- Login -->


              <form onsubmit="return false;" v-if="action==='login'">
                <div class="field" style="margin-top: 20px;">
                  <div class="control">
                    <input v-model="username" id="login" class="input" type="email" placeholder="Usuário" autofocus="">
                  </div>
                </div>

                <div class="field">
                  <div class="control">
                    <input v-model="password" class="input" type="password" placeholder="Senha">
                  </div>
                </div>
                <!--
                <div class="field">
                  <label class="checkbox">
                  <input type="checkbox">
                  Remember me
                  </label>
                </div>
                -->
                <button @click="submitLogin" class="button is-block is-link is-fullwidth" v-bind:class="processando ? 'is-loading' : ''" :disabled="!loginValid">Login</button>

                <p class="has-text-grey" style="padding-top: 12px;">
                  <span v-if="action !== 'recuperar'"><a @click="action='recuperar'">Recuperar Senha</a> &nbsp;</span>
                  <br>
                  <a @click="instrumentState.modals.termosDeUso = true">Termos de Uso</a> &nbsp;
                </p>
              </form>

              <!-- Recuperar -->

              <form onsubmit="return false;" v-if="action==='recuperar'">
                <div class="field">
                  <div class="control">
                    <input v-model="username" class="input" type="email" placeholder="Usuário" autofocus="">
                  </div>
                </div>

                <!--
                <div class="field">
                  <label class="checkbox">
                  <input type="checkbox">
                  Remember me
                  </label>
                </div>
                -->
                <button @click="submitSolicitar" class="button is-block is-link is-fullwidth" v-bind:class="processando ? 'is-loading' : ''" :disabled="!solicitarValid">Solocitar troca de senha</button>
                <p class="has-text-grey" style="padding-top: 12px;">
                  <span v-if="action !== 'login'"><a @click="action='login'">Login</a></span>
                  <br>
                  <a @click="instrumentState.modals.termosDeUso = true">Termos de Uso</a> &nbsp;
                </p>
              </form>

              <!-- Definir -->

              <form onsubmit="return false;" v-if="action==='definir'">

                <p style="font-size: 0.9em;padding-bottom: 6px;" class="has-text-weight-semibold">Informe e confirme sua nova senha</p>
                <div class="field">
                  <div class="control">
                    <input v-model="password" class="input" type="password" placeholder="nova senha">
                  </div>
                </div>

                <div class="field">
                  <div class="control">
                    <input v-model="passwordComfirm" class="input" type="password" placeholder="confirmar senha">
                  </div>
                </div>
                <p v-if="password !== passwordComfirm" class="help is-danger">Os dois campos devem ser iguais</p>
                <p v-if="password.length && password.length < 6" class="help is-danger">A senha deve ter no mínimo 6 caracteres</p>
                <!--<p v-if="scorePassword < 60" class="help is-warning">sua senha não é muito forte.</p>-->

                <!--
                <div class="field">
                  <label class="checkbox">
                  <input type="checkbox">
                  Remember me
                  </label>
                </div>
                -->
                <button @click="submitDefinir" class="button is-block is-link is-fullwidth" v-bind:class="processando ? 'is-loading' : ''" :disabled="!definirValid">Definir Senha</button>
                <p class="has-text-grey" style="padding-top: 12px;">
                  <a @click="instrumentState.modals.termosDeUso = true">Termos de Uso</a> &nbsp;
                  <br>
                  <span v-if="action !== 'login'" style="font-size: 0.9em;"><a @click="action='login'">Ir para login</a></span>
                </p>
              </form>

            </div>
            <p v-if="action!=='definir'" style="font-size: 0.9em;" class="has-text-weight-semibold">Para testar a plataforma, utilize as credenciais:</p>
            <p v-if="action!=='definir'" style="font-size: 0.9em;">Usuário: procaldemo@ipt.br</p>
            <p v-if="action!=='definir'" style="font-size: 0.9em;">Senha: procaldemo</p>
          </div>
        </div>
      </div>
    </section>



    <!-- #Termos de uso -->
    <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.termosDeUso ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content" style="width: 80%;">
        <div class="box">

          <article class="media">
            
            <div class="media-content">

              <h6 class="title is-6">Termos de Uso da Plataforma IPT ProCal</h6>

<div class="help-modal-content"><div><div class="WordSection1"><p class="MsoNormal">A plataforma IPT Procal foi desenvolvida pelo Laboratório
de Metrologia Elétrica do Instituto de Pesquisas Tecnológicas do Estado de São
Paulo S.A. - IPT (LME-IPT)para permitir que os seus clientes possam acessar os
dados das calibrações contratadas de forma mais ágil, flexível e com recursos
analíticos.</p> <p class="MsoNormal">O domínio procal.ipt.br e todas as páginas, telas, módulos,
figuras, imagens e funcionalidades relacionados à plataforma IPT Procal,
incluindo, mas não se limitando, à página procal.ipt.br (www.ipt.br), tudo em
conjunto denominado simplesmente “PLATAFORMA” neste documento, pertence ao
Laboratório de Metrologia Elétrica do Instituto de Pesquisas Tecnológicas do
Estado de São Paulo S.A. (“IPT”).</p> <p class="MsoNormal">Os dados trafegados para dentro e fora do site, tais como
senhas e os dados dos instrumentos são criptografados. O site também utiliza
cookies para permitir uma melhor experiência e funcionalidade.</p> <p class="MsoNormal">1.            Aceitação aos Termos de Uso</p> <p class="MsoNormal">1.1          Ao acessar ou visitar, de qualquer forma, a
Plataforma, os clientes, visitantes ou quaisquer usuários, sejam pessoas
físicas ou jurídicas (denominados simplesmente “CLIENTES”) deverão estar de
acordo com estes Termos de Uso da Plataforma (“TERMOS DE USO”) e obedecer todas
as regras aqui constantes. Portanto, se não houver concordância com este
documento parcial ou integralmente, a PLATAFORMA ou quaisquer de seus conteúdos
e/ou serviços não devem ser acessados.</p> <p class="MsoNormal">1.2          O IPT reserva o direito de alterar ou modificar
estes TERMOS DE USO ao seu exclusivo critério, a qualquer momento. Qualquer
alteração ou modificação a estes entrará em vigor imediatamente após a
publicação na PLATAFORMA e/ou no website. O CLIENTE é responsável por analisar
periodicamente a mais atualizada versão destes TERMOS DE USO.</p> <p class="MsoNormal">1.3          O uso da PLATAFORMA constitui a aceitação de
quaisquer alterações ou modificações feitas nos TERMOS DE USO.</p> <p class="MsoNormal">2.            Clientes e Usuários</p> <p class="MsoNormal">2.1          O uso da PLATAFORMA está disponível apenas para
os clientes do Laboratório de Metrologia Elétrica do IPT.</p> <p class="MsoNormal">2.2          Mediante um cadastro de login e senha, o
CLIENTE pode ter acesso aos dados de instrumentos calibrados no Laboratório de
Metrologia Elétrica do IPT.</p> <p class="MsoNormal">2.3          A responsabilidade pela segurança, conservação
confidencialidade da senha e sigilo das informações é do CLIENTE. Os usuários
da PLATAFORMA devem ter vínculo com a empresa do cliente contratante do
serviço, se pessoa jurídica, ou ser o próprio cliente, se pessoa física.</p> <p class="MsoNormal">2.4          É expressamente proibida a divulgação da senha
para usuários sem vínculo com o CLIENTE do IPT.</p> <p class="MsoNormal">2.5          O IPT não se responsabiliza por qualquer perda
de senha ou por vazamento de senha para terceiros ou por quaisquer prejuízos ou
danos decorrentes da perda de senha.</p> <p class="MsoNormal">3.            Uso dos Serviços</p> <p class="MsoNormal">3.1          O acesso à PLATAFORMA e/ou a utilização dos
serviços poderá se dar por meio de computadores e dispositivos móveis,
incluindo smartphones, tablets ou qualquer outro dispositivo relacionado ou
assemelhado, seja por meio de aplicações/aplicativos específicos ou não.
Entretanto, o IPT não se responsabiliza por eventual incompatibilidade ou falha
ou limitação de recursos, decorrente da versão do navegador ou do sistema
operacional do dispositivo. </p> <p class="MsoNormal">3.2          O CLIENTE não poderá permitir que terceiros
acessem a PLATAFORMA, sob pena de bloqueio do acesso e multa por quebra de
confidencialidade. Em caso de perda de dados, violação de segurança ou uso não
autorizado de sua conta, você deverá notificar o IPT imediatamente, por meio
dos canais de comunicação indicados na PLATAFORMA ou pelo e-mail  Lme@ipt.br.</p> <p class="MsoNormal">3.3          Entende-se por “terceiros”, usuários sem
vínculo formal de trabalho com o CLIENTE contratante do serviço.</p> <p class="MsoNormal">3.4          O servidor utilizado pelo IPT poderá sofrer
interrupções por diversos motivos, tais como manutenção, defeito, queda de
energia por tempo prolongado, entre outros. O IPT não se compromete a manter o
acesso à PLATAFORMA durante 24 horas por dia, em 7 dias na semana. O IPT também
não poderá ser responsabilizado por quaisquer prejuízos decorrentes de falha no
acesso.</p> <p class="MsoNormal">3.5          O IPT não se responsabiliza por perdas ou danos
de dados contidos na PLATAFORMA ou de quaisquer de seus serviços. O uso dos
serviços poderá ser interrompido a qualquer momento por decisão única e
exclusiva do IPT, sem aviso prévio ou comunicado oficial.</p> <p class="MsoNormal">4.            Uso do conteúdo da Plataforma</p> <p class="MsoNormal">4.1          Para os fins destes TERMOS DE USO, “CONTEÚDO”
inclui, mas não se limita a dados, imagens, textos, gráficos, fotos, equações,
combinações audiovisuais, recursos interativos, comentários, propagandas,
anúncios publicitários, software e aplicativos, dentre outros materiais que
você poderá, por meio da PLATAFORMA, ter acesso e/ou utilizar.</p> <p class="MsoNormal">4.2          O IPT possui os direitos autorais e a
exclusividade na propriedade intelectual da PLATAFORMA, do seu CONTEÚDO e de
todas as funcionalidades e recursos disponíveis.</p> <p class="MsoNormal">4.3          O CONTEÚDO acessado não poderá ser
compartilhado, transmitido, divulgado em qualquer tipo de mídia, nem ser
fornecido a terceiros e utilizado para outros fins não relacionados ao serviço
contratado. </p> <p class="MsoNormal">4.4          A PLATAFORMA dispõe de determinadas
funcionalidades que permitem com que os usuários enviem ou publiquem textos
e/ou outros conteúdos. Neste sentido, o CLIENTE aceita, reconhece e se
compromete a:</p> <p class="MsoNormal">(a) não compartilhar, transmitir, enviar, disponibilizar,
exibir ou publicar na PLATAFORMA qualquer conteúdo que consista em propriedade
intelectual de terceiros ou que esteja protegido por direitos autorais, por
segredo de negócio ou por qualquer outra forma de proteção de direitos de
titularidade de terceiros;</p> <p class="MsoNormal">(b) não compartilhar, transmitir, enviar, disponibilizar,
exibir ou publicar na PLATAFORMA qualquer conteúdo impróprio;</p> <p class="MsoNormal">(c) não realizar o download de qualquer conteúdo, a menos
que tal opção esteja expressamente liberada na PLATAFORMA;</p> <p class="MsoNormal">(d) não reproduzir, distribuir, transmitir, exibir, vender,
licenciar ou explorar comercialmente qualquer conteúdo;</p> <p class="MsoNormal">(e) não fraudar, desativar ou de qualquer forma interferir
em características relacionadas à segurança da PLATAFORMA e do seu CONTEÚDO.</p> <p class="MsoNormal">5.            Obrigações e deveres do Cliente</p> <p class="MsoNormal">5.1          O CLIENTE assume toda e qualquer
responsabilidade pela veracidade do conteúdo adicionado à PLATAFORMA, ficando
responsável ainda por quaisquer erros cometidos e suas consequências.</p> <p class="MsoNormal">5.2          Todo e qualquer conteúdo, incluindo as marcas e
os nomes de domínios, que sejam disponibilizados diretamente pelo IPT na
PLATAFORMA pertencem exclusivamente ao IPT sob reserva de direitos autorais e
outros direitos de propriedade intelectual nos termos da lei. Esses conteúdos
próprios do IPT não se confundem com o conteúdo do certificado e dos dados da
calibração, que são de propriedade do CLIENTE.</p> <p class="MsoNormal">5.3          O CLIENTE  admite e concorda que a entrega do
serviço contratado não está vinculada ao acesso à PLATAFORMA. Embora a PLATAFORMA
conte com a opção de download de documentos, a entrega oficial do certificado
de calibração se dará somente via e-mail corporativo (quando emitido em formato
eletrônico) ou em formulário oficial com timbre e assinaturas (em meio físico).
Documentos baixados da PLATAFORMA não possuem  assinatura e validade legal.</p> <p class="MsoNormal">5.4          O CLIENTE não poderá reproduzir, modificar,
realizar engenharia reversa, compilar, descompilar, transmitir, publicar,
sublicenciar, permitir, autorizar, alugar, vender, distribuir, ou, de qualquer
outra forma, utilizar qualquer conteúdo, funcionalidade, software ou material
da PLATAFORMA de forma não permitida nesses TERMOS DE USO, sem prévia e
expressa autorização, por escrito, do IPT.</p> <p class="MsoNormal">5.5          O CLIENTE se compromete e garante que não
registrará nem tentará registrar nomes de domínio na internet, perante
quaisquer entidades, nacionais ou estrangeiras, contendo marcas, nomes e/ou
elementos pertencentes ao IPT, ou relacionados a esta PLATAFORMA ou a seus
produtos e serviços.</p> <p class="MsoNormal">5.6          O CLIENTE se compromete a:</p> <p class="MsoNormal">(a) não reivindicar ou buscar obter registro ou proteção de
quaisquer direitos de propriedade intelectual ou direitos autorais sobre os
conteúdos pertencentes ao IPT;</p> <p class="MsoNormal">(b) não utilizar qualquer sistema automatizado (incluindo
"robôs", "spiders" ou "offline readers") que
permita o acesso à PLATAFORMA de forma automática e com quantidade e velocidade
superiores ao que seria possível de fosse feito por pessoas naturais;</p> <p class="MsoNormal">(c) não tentar coletar e/ou extrair dados ou qualquer
informação de outros clientes;</p> <p class="MsoNormal">(d) cumprir com todas as leis, normas e regulamentos
aplicáveis, no Brasil ou no exterior.</p> <p class="MsoNormal">6.            Utilização da Marca IPT </p> <p class="MsoNormal">6.1          O uso e acesso a PLATAFORMA não dão ao cliente
o direito de utilização da marca IPT, em nenhuma mídia, impressa ou eletrônica,
gratuita ou onerosa, tais como: peças promocionais/publicitárias; banners;
informativos; catálogos, embalagens ou rótulos de produtos; sites; revistas,
jornais; cartazes de feiras e eventos em geral.</p> <p class="MsoNormal">6.2          Não é permitido ao CLIENTE relacionar o nome do
IPT como seu parceiro, certificador de qualidade ou tecer nenhuma outra menção
ou consideração que induza o terceiros  a crer que o IPT aprova tecnicamente o
instrumento ou a regra de decisão ou o critério para análise dos dados.</p> <p class="MsoNormal">6.3          A utilização indevida da marca IPT sujeitará o
CLIENTE à aplicação de multa de 100% do valor estabelecido no respectivo
orçamento ou proposta de trabalho, sem prejuízo das sanções civis e penais
aplicáveis.</p> <p class="MsoNormal">7.            Utilização comercial da Plataforma</p> <p class="MsoNormal">7.1          O uso comercial da PLATAFORMA é prerrogativa
única e exclusiva do IPT.</p> <p class="MsoNormal">7.2          O CLIENTE não poderá  explorar ou utilizar
comercialmente, por qualquer meio, qualquer parte dos serviços ou dos conteúdos
da PLATAFORMA. Para os fins do presente, exploração ou utilização com
finalidade comercial inclui, mas não se limita a (i) venda ou disponibilização,
mediante recebimento de retribuição ou benefício, de acesso a esses serviços
e/ou conteúdos, (ii) a venda ou comercialização de publicidade, patrocínios ou
promoções associados a esses serviços ou conteúdos.</p> <p class="MsoNormal">7.3          O CLIENTE não poderá reproduzir ou copiar o
CONTEÚDO da PLATAFORMA com finalidade comercial de qualquer espécie e/ou de
forma que se caracterize concorrência desleal contra o IPT.</p> <p class="MsoNormal">8.            Responsabilidades do IPT e do Cliente</p> <p class="MsoNormal">8.1          O IPT empregará seus maiores esforços para
assegurar que todas as informações e dados oferecidos na PLATAFORMA sejam tão
atualizados, precisos e completos quanto possível. Entretanto, em nenhuma
circunstância, o IPT poderá ser responsabilizado quanto à integridade,
atualidade e exatidão de tais informações e dados, não sendo responsável,
perante o CLIENTE ou qualquer terceiro, por quaisquer danos indiretos,
consequentes, exemplares, incidentais, especiais ou punitivos, inclusive, sem
limitação, por lucros cessantes, resultantes do uso da PLATAFORMA ou dos
serviços nela oferecidos.</p> <p class="MsoNormal">8.2          O CLIENTE concorda em defender, indenizar e
isentar o IPT, seus diretores, funcionários e representantes, de toda e
qualquer demanda judicial, danos, obrigações ou perdas (incluindo, sem
limitação, honorários advocatícios) decorrentes:</p> <p class="MsoNormal">(a) da violação de qualquer disposição destes TERMOS DE USO
ou</p> <p class="MsoNormal">(b) da violação por qualquer direito de terceiros.</p> <p class="MsoNormal">8.3          O IPT não garante que o acesso ao site seja
livre de erros ou problemas, decorrentes de casos fortuitos, internos ou
externos, casos de força maior ou por outros casos não sujeitos a controle do
IPT. Desta forma, o IPT não assume qualquer obrigação ou responsabilidade por
quaisquer:</p> <p class="MsoNormal">(a) danos pessoais ou materiais, de qualquer natureza, que
resulte do seu acesso e do uso da PLATAFORMA;</p> <p class="MsoNormal">(b) qualquer acesso ou uso dos servidores protegidos do IPT
e/ou de qualquer informação ou dado ali armazenado;</p> <p class="MsoNormal">(c) qualquer interrupção de acesso à PLATAFORMA;</p> <p class="MsoNormal">(d) qualquer vírus ou dispositivo malicioso (e congêneres)
que possa atacar o equipamento do CLIENTE em decorrência do acesso, utilização
ou navegação na PLATAFORMA ou como consequência do download, utilização ou
acesso a qualquer conteúdo da Plataforma.</p> <p class="MsoNormal">9.            Contratação de Serviços na Plataforma</p> <p class="MsoNormal">9.1          A contratação de qualquer serviço na PLATAFORMA
ou relacionado à PLATAFORMA será regida por um contrato que deve ser aceito e
aprovado pelo CLIENTE, após recebimento e análise de um orçamento ou proposta
do IPT. Esse contrato é a base jurídica para o fornecimento de serviços pelo
IPT e possuem termos e condições adicionais que se aplicam a cada tipo de
solução oferecida. Portanto, não haverá nenhuma cobrança do IPT sem a anuência
e aprovação do CLIENTE.</p> <p class="MsoNormal">9.2          Estes TERMOS DE USO serão regidos,
exclusivamente, pelas leis brasileiras e suas controvérsias deverão ser
solucionadas entre o CLIENTE e o IPT, sendo também o foro da Comarca da Capital
de São Paulo o competente para dirimir qualquer questão relativa a ele.</p> <p class="MsoNormal">10.          Prazo e vigência dos Termos de Uso</p> <p class="MsoNormal">10.1       Estes TERMOS DE USO permanecerão em plena força e
vigor enquanto o CLIENTE tiver acesso a PLATAFORMA.</p> <p class="MsoNormal">&nbsp;</p></div></div></div>


            </div>
          </article>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.termosDeUso = false"></button>
    </div>
    <!-- /Termos de uso -->




  </div>
</template>

<script>

import PouchDB from 'pouchdb'
import pouchAuth from 'pouchdb-authentication'
import axios from 'axios'

PouchDB.plugin(pouchAuth);

  
export default {
  name: 'Login',
  data () {
    const token = this.$route.query.token
    var loginDB = new PouchDB(window.DB_ADDR + '_users', {skip_setup: true, ajax: {timeout: 5000}})
    return {
      loginDB: loginDB,
      action: token ? 'definir' : 'login',
      token: token,
      username: '',
      password: '',
      passwordComfirm: '',
      processando: null,
      instrumentState: INSTRUMENT_STORE.state,
      redeBloqueada: false
    }
  },
  mounted () {
    /*var client = axios({
      method: 'get',
      url: window.DB_ADDR
    })
    .then((response) => {
      //console.log(response)
    })
    .catch((error) => {
      window.DB_ADDR = 'https://procal.ipt.br/_couch/'
      console.log('definindo configuracao alternativa.')
      //this.redeBloqueada = true
      //this.$toasted.show('Porta 15984 bloqueada. Verificar com departamento de TI.', {icon: 'error'})
    })
    .finally(() => {
    })*/
  },
  methods: {
    submitSolicitar() {
      this.processando = true
      window.setTimeout(() => {
        var client = axios({
          method: 'post',
          url: 'https://procal.ipt.br/couch_user_manager/request_password_reset',
          withCredentials: true,
          data: {
            user_name: this.username
          }
        })
        .then((response) => {
          this.$toasted.show('Um e-mail foi enviado solicitando a redefinição da senha.', {
            icon: 'done'
          })
        })
        .catch((error) => {
          this.$toasted.show('Não foi possível solicitar a troca de senha.', {
            icon: 'error'
          })
        })
        .finally(() => {
          this.processando = false
          this.action = 'login'
        })
      }, 500)
    },
    redirectLogin() {
      window.location.replace(document.location.origin+document.location.pathname+"?/#/?action=login")
    },
    submitDefinir() {
      this.processando = true

      window.setTimeout(() => {
        var promise
        if (this.$route.query.token === 'MOCK_TOKEN') {
          promise = new Promise((resolve, reject) => resolve('ok'))
        } else {
          promise = axios({
            method: 'post',
            url: 'https://procal.ipt.br/couch_user_manager/reset_password',
            withCredentials: true,
            data: {
              token: this.$route.query.token,
              new_password: this.password
            }
          })
        }
        promise.then((response) => {
          if (this.$route.query.name) {
            this.username = this.$route.query.name
            return response
          } else {

            /*this.$toasted.show('Senha definida. Informe o usuário para realizar o login.', {
              icon: 'done'
            })*/

            this.$toasted.show('Senha definida. Redirecionando para tela de login...', {
              icon: 'done'
            })
            //this.action = 'login'
            window.setTimeout(() => {
              this.redirectLogin()
            }, 2400)
          }
        })
        .then((response) => {
          if (response) {
            this.$toasted.show('Senha definida. Realizando login...', {
              icon: 'done'
            })
            this.submitLogin()
          }
        })
        .catch((error) => {
          console.log(error)
          /*this.$toasted.show('Não foi possível definir a senha. Caso já tenha definido a senha, clique em login. Mensagem do erro: '+error['message'], {
            icon: 'error'
          })*/
          this.$toasted.show('Não foi possível definir a senha. Caso já tenha feito isto anteriormente, clique em "ir para login"', {
            icon: 'error'
          })
        })
        .finally(() => {
          this.processando = false
        })
      }, 100)
    },
    submitLogin() {
      var valid = true
      if (valid) {
        localStorage.setItem('ms_username', this.username);
        
        this.processando = true
        
        window.setTimeout(() => {
          this.loginDB.login(this.username, this.password)
          .then((response) => {
            if(!response) return
            
            if (response.ok) {
              this.$emit('check_login')
            }
          })
          .catch((err) => {
            console.log(err)
            if (err.name === 'unauthorized') {
              this.$toasted.show('Usuário ou senha inválido', {icon: 'exclamation-circle'} )
            } else {
              this.$toasted.show('Não foi possível entrar agora, tente em breve. Nome do erro: '+err.name, {icon: 'exclamation-circle'} )
            }
          })
          .finally(() => {
            window.setTimeout(() => {
              this.processando = false
            }, 2000)
          })
        }, 50)

        
      } else {
        console.log('error submit!!');
        return false;
      }
    }
  },
  computed: {
    scorePassword () {
        var score = 0;
        if (!this.password)
            return score;

        // award every unique letter until 5 repetitions
        var letters = new Object();
        for (var i=0; i<this.password.length; i++) {
            letters[this.password[i]] = (letters[this.password[i]] || 0) + 1;
            score += 5.0 / letters[this.password[i]];
        }

        // bonus points for mixing it up
        var variations = {
            digits: /\d/.test(this.password),
            lower: /[a-z]/.test(this.password),
            upper: /[A-Z]/.test(this.password),
            nonWords: /\W/.test(this.password),
        }

        var variationCount = 0;
        for (var check in variations) {
            variationCount += (variations[check] == true) ? 1 : 0;
        }
        score += (variationCount - 1) * 10;

        return parseInt(score);
    },
    solicitarValid () {
      return this.username !== ''
    },
    loginValid () {
      return this.solicitarValid && this.password !== ''
    },
    definirValid () {
      return this.password !== '' && this.password === this.passwordComfirm && this.password.length >= 6
    }
  }
}
</script>

<style scoped>
</style>
